/* Mobile drawer: single <details>, ESC close, scroll lock, accordion groups */
(function () {
  const qs = (sel, ctx = document) => ctx.querySelector(sel);
  const qsa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const lockScroll = (lock) => {
    document.documentElement.classList.toggle('overflow-hidden', lock);
    document.body.classList.toggle('overflow-hidden', lock);
  };

  const syncSummaryAria = (detailsEl) => {
    const summary = qs('summary', detailsEl);
    if (summary) summary.setAttribute('aria-expanded', detailsEl.open ? 'true' : 'false');
  };

  const setupAccordionGroups = (root) => {
    // Sibling-exclusive accordions in any [data-accordion-group]
    qsa('[data-accordion-group]', root).forEach((group) => {
      const items = qsa('details', group);
      items.forEach((item) => {
        const sum = qs('summary', item);
        if (sum) sum.setAttribute('aria-expanded', item.open ? 'true' : 'false');

        item.addEventListener('toggle', () => {
          const s = qs('summary', item);
          if (s) s.setAttribute('aria-expanded', item.open ? 'true' : 'false');
          if (item.open) {
            items.forEach((sib) => {
              if (sib !== item) {
                sib.open = false;
                const ss = qs('summary', sib);
                if (ss) ss.setAttribute('aria-expanded', 'false');
              }
            });
          }
        });
      });
    });
  };

  const initMobileDrawer = (scope = document) => {
    const drawer = qs('#mobile-drawer', scope);
    if (!drawer) return;

    const onOpenChange = () => {
      syncSummaryAria(drawer);
      lockScroll(drawer.open);
    };

    // Toggle scroll lock when open state changes
    drawer.addEventListener('toggle', onOpenChange);

    // Close on ESC
    drawer.addEventListener('keyup', (e) => {
      if ((e.code || '').toUpperCase() === 'ESCAPE' && drawer.open) {
        drawer.open = false;
        onOpenChange();
        const summary = qs('summary', drawer);
        summary?.focus();
      }
    });

    // Sync aria-expanded on nested accordions
    qsa('.menu-accordion > summary', drawer).forEach((sum) => {
      sum.addEventListener('click', () => {
        const d = sum.parentNode;
        setTimeout(() => {
          sum.setAttribute('aria-expanded', d.open ? 'true' : 'false');
        }, 0);
      });
    });

    setupAccordionGroups(drawer);
    onOpenChange();
  };

  document.addEventListener('DOMContentLoaded', () => initMobileDrawer(document));
  document.addEventListener('shopify:section:load', (e) => initMobileDrawer(e.target));
})();